import React from "react";
import { useTranslation } from "react-i18next";
import { getNewsPagination } from "../../helpers/Api/apiHelper";
import { getLanguage } from "../../helpers/storageHelper";
import { Link } from "react-router-dom";

function NewsSection() {
    const { t } = useTranslation();
    const [newsData, setNewsData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const language = getLanguage();

    React.useEffect(() => {
        let mounted = true;
        const getNews = async () => {
            const response = await getNewsPagination(0);
            if (response && response.success) {
                if (mounted) {
                    setNewsData(response.success.data.slice(0, 3));
                    setLoading(false);
                }
            }
            else {
                if (mounted) {
                    setNewsData(null);
                    setLoading(false);
                }
            }
        };
        getNews();
        return () => { mounted = false; };
    }, []);

    if (loading || !newsData || newsData.length === 0) return null;

    const title = item => (language == 1 ? item?.title : item?.enTitle);
    const content = item => (language == 1 ? item?.content : item?.enContent);

    const featured = newsData[0];
    const side = newsData.slice(1, 3);

    return (
        <section className="landing-section landing-section-alt">
            <div className="container">
                <div className="landing-news-head">
                    <div>
                        <div className="landing-eyebrow">{t("newsEyebrow")}</div>
                        <h2 className="landing-heading">{t("newsTitle")}</h2>
                    </div>
                    <Link className="landing-view-all" to="/news">{t("newsViewAll")} →</Link>
                </div>
                <div className="landing-news-grid">
                    <div className="landing-news-featured">
                        <img className="landing-news-featured-img" src={featured?.mainImageUrl} alt={title(featured)} />
                        <div className="landing-news-featured-body">
                            <div className="landing-news-date">{featured?.date}</div>
                            <h3 className="landing-news-title">{title(featured)}</h3>
                            <p className="landing-news-excerpt">{content(featured)}</p>
                            <Link className="landing-news-more" to={`/newsDetails?id=${featured?.id}`} state={featured}>{t("newsReadMore")} →</Link>
                        </div>
                    </div>
                    <div className="landing-news-list">
                        {side.map(item => (
                            <div className="landing-news-item" key={item?.id}>
                                <div className="landing-news-date">{item?.date}</div>
                                <h3 className="landing-news-title">{title(item)}</h3>
                                <p className="landing-news-excerpt">{content(item)}</p>
                                <Link className="landing-news-more" to={`/newsDetails?id=${item?.id}`} state={item}>{t("newsReadMore")} →</Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
export default NewsSection;